"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryEInstantsGroupedList = void 0;
var HistoryEInstantsGroupedList = /** @class */ (function (_super) {
    __extends(HistoryEInstantsGroupedList, _super);
    function HistoryEInstantsGroupedList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTransactionDateSorted = function () {
            var einstantsList = new HistoryEInstantsGroupedList();
            if (_this.length > 0) {
                _this.sort(function (x, y) {
                    var transactionDateX = !!x.transactionDate ? x.transactionDate : 0;
                    var transactionDateY = !!y.transactionDate ? y.transactionDate : 0;
                    return transactionDateX > transactionDateY ? -1 : 1;
                }).forEach(function (x) {
                    einstantsList.push(x);
                });
            }
            return einstantsList;
        };
        return _this;
    }
    return HistoryEInstantsGroupedList;
}(Array));
exports.HistoryEInstantsGroupedList = HistoryEInstantsGroupedList;
//# sourceMappingURL=HistoryEInstantsGroupedList.js.map